import React from 'react';
import Flagship from '../../core/flagship';
import Field from '../records/Field';
import {connect} from 'react-redux';
import { Loader, Header, Grid, Modal, Button, Icon, Label } from 'semantic-ui-react';
import {empty, renderFieldValue} from '../../utils/helpers';

class LineItemPricingModal extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = this.getInitialState();
        this.editName = this.editName.bind(this);
    }

    getInitialState() {
        return {
            loading:true,
            id: this.props.lineItemId,
            line_item_key: '',
            line_item_name: '',
            line_item_type: '',
            parent_rfp: 0,
            vendor: '',
            cogs: '',
            price: '',
            proposal_strategist: '',
            lineItemData: [],
            errors: []
        };
    }

    componentDidMount() {
        // Get Form
        let self = this;
        Flagship.get(
            'line-item/read/' + self.props.lineItemId,
            {
                withData: true
            },
            function (response) {
                if (response.data.success === true) {

                    self.setState(
                        response.data.result,
                        function() {
                            self.setState({
                                loading:false,
                                lineItemData:response.data.data
                            });
                    });


                } else {

                    Flagship.error(
                        "Error getting line item form from Flagship API server.",
                        self.props.recordId,
                        self.props.userId
                    );
                }
            },
            function (err) {

                Flagship.error(
                    "Error getting line item form from Flagship API server: " + err,
                    self.props.recordId,
                    self.props.userId
                );
            }
        );
    }

    addError(fieldId) {

        let errors = this.state.errors;

        if (errors.indexOf(fieldId) === -1) {
            errors.push(fieldId);
        }

        this.setState({
            errors: errors
        });
    }

    clearError(fieldId) {

        let errors = this.state.errors;
        for (var i = errors.length - 1; i >= 0; i--) {
            if (errors[i] === fieldId) {
                errors.splice(i, 1);
            }
        }

        this.setState({
            errors: errors
        });
    }

    onChange(e, data, field) {

        let parentOnChange = this.props.onChange;

        let newState = Object.assign({}, this.state);

        newState[field] = data;

        this.setState(newState, function() {
            parentOnChange(this.state);
        });
    }

    editName() {
        this.setState({
            editingName: true
        });
    }

    render() {

        if( this.state.loading === true ) {
            return (
                <Loader />
            );

        } else {

            let self = this;

            return (
                <Modal
                    open={this.props.open}
                    onClose={this.props.cancelUpdate}
                    closeIcon
                >
                    <Header icon='pin' content='Edit Pricing' />
                    <Modal.Content>
                        <div>
                            <Grid>
                                <Grid.Column width={10}>
                                    <Header as="h3">Line Item Info</Header>
                                    {!empty(this.state.lineItemData) ? this.state.lineItemData.map(function(item, i) {
                                        return (
                                            <div key={"line-item-pricing-form-field-" + i} className="flagship-single-field single-record-single-field">
                                                <Label>{item.label}</Label><br/>
                                                <div className="field-value">
                                                    {renderFieldValue(item.field_value, item.validation)}
                                                </div>
                                            </div>
                                        );
                                    }) : <div>No line item data to display.</div> }
                                </Grid.Column>
                                {this.props.userRole === "proposal_strategist" || this.props.userRole === "admin" ?
                                    <Grid.Column width={6}>
                                        <Header as="h3">Pricing Info</Header>
                                        <Field
                                            id="pricing-vendor-field"
                                            addError={self.addError.bind(self)}
                                            clearError={self.clearError.bind(self)}
                                            value={this.state.vendor === null ? '' : this.state.vendor}
                                            label="Vendor"
                                            options=""
                                            autofocus={true}
                                            default=""
                                            attributes=""
                                            details=""
                                            key="pricing-vendor-field"
                                            prefix=""
                                            suffix=""
                                            role_required="proposal_strategist"
                                            required={false}
                                            multi={false}
                                            placeholder="Enter Vendor..."
                                            name="vendor"
                                            type="text"
                                            onChange={(e, data) => self.onChange(e, data, "vendor")}
                                        />
                                        <Field
                                            id="pricing-price-field"
                                            addError={self.addError.bind(self)}
                                            clearError={self.clearError.bind(self)}
                                            value={this.state.price === null ? '' : this.state.price }
                                            label="Price"
                                            options=""
                                            default=""
                                            attributes=""
                                            details=""
                                            key="pricing-price-field"
                                            prefix=""
                                            suffix=""
                                            role_required="proposal_strategist"
                                            required={false}
                                            multi={false}
                                            type="text"
                                            placeholder="Enter Price..."
                                            name="price"
                                            filterInput="money"
                                            validation="money"
                                            onChange={(e, data) => self.onChange(e, data, "price")}
                                        />
                                        <Field
                                            id="pricing-cogs-field"
                                            addError={self.addError.bind(self)}
                                            clearError={self.clearError.bind(self)}
                                            value={this.state.cogs === null ? '' : this.state.cogs }
                                            label="COGS"
                                            options=""
                                            default=""
                                            attributes=""
                                            details=""
                                            key="pricing-cogs-field"
                                            prefix=""
                                            suffix=""
                                            role_required="proposal_strategist"
                                            required={false}
                                            multi={false}
                                            type="text"
                                            placeholder="Enter COGS..."
                                            name="cogs"
                                            filterInput="money"
                                            validation="money"
                                            onChange={(e, data) => self.onChange(e, data, "cogs")}
                                        />
                                        <Field
                                            id="pricing-proposal-strategist-field"
                                            addError={self.addError.bind(self)}
                                            clearError={self.clearError.bind(self)}
                                            value={this.state.proposal_strategist === null ? '' : this.state.proposal_strategist }
                                            label="Proposal Strategist"
                                            options=""
                                            default=""
                                            attributes=""
                                            details=""
                                            key="pricing-proposal-strategist-field"
                                            prefix=""
                                            suffix=""
                                            role_required="proposal_strategist"
                                            required={false}
                                            multi={false}
                                            type="text"
                                            placeholder="Enter Name..."
                                            name="proposal_strategist"
                                            onChange={(e, data) => self.onChange(e, data, "proposal_strategist")}
                                        />

                                    </Grid.Column>: <div>Access Denied</div> }
                            </Grid>
                        </div>

                    </Modal.Content>
                    <Modal.Actions>
                        {!empty(self.state.errors) && self.state.errors.length > 0 ?
                            <span>Fix errors before saving.</span>
                            :
                            <Button primary onClick={self.props.updateLineItemPricing}>
                                <Icon name='save' /> Save Pricing
                            </Button>
                        }
                        <Button color='grey' onClick={this.props.cancelUpdate}>
                            <Icon name='dont' /> Cancel
                        </Button>
                    </Modal.Actions>
                </Modal>


            );

        }
    }
}

function mapStateToProps(state) {
    return {
        username: state.main.username,
        userId: state.main.userId,
        userRole: state.main.userRole
    };
}

export default connect(
    mapStateToProps,
    null
)(LineItemPricingModal);


// WEBPACK FOOTER //
// ./src/components/modals/LineItemPricingModal.js